module.exports = __webpack_public_path__ + "media/images/pc/page_common/reservation_card_kimono-65b0915747d9c55823c6fc4fde97890b.png";